import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-store-selection-dialog',
  templateUrl: './store-selection-dialog.component.html',
  styleUrls: ['./store-selection-dialog.component.scss'],
  standalone: false
})
export class StoreSelectionDialogComponent {
  allStores: any[] = [];
  sushiStores: any[] = [];
  bentoStores: any[] = [];
  tabSelections: Array<Set<number>> = [new Set(), new Set(), new Set()];
  tabSelectedOnly: boolean[] = [false, false, false];
  tabIndex = 0;
  prevTabIndex = 0;
  searchText = '';
  initialized = false;
  includeSameStoreLY = false;
  lastYearSameWeekStoreInfo: any = {};

  constructor(
    public dialogRef: MatDialogRef<StoreSelectionDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.allStores = data.allStores || [];
    this.sushiStores = data.sushiStores || [];
    this.bentoStores = data.bentoStores || [];
    this.tabIndex = typeof data.tabIndex === 'number' ? data.tabIndex : 0;
    this.includeSameStoreLY = !!data.includeSameStoreLY;
    this.lastYearSameWeekStoreInfo = data.lastYearSameWeekStoreInfo || [];
    setTimeout(() => {
      if (!this.initialized) {
        this.selectAllTabs();
        if (data.selectedStoreIds && data.selectedStoreIds.length > 0) {
          this.selectedStoreIds = new Set(data.selectedStoreIds);
        }
        this.initialized = true;
      }
    });

  }

  get selectedStoreIds(): Set<number> {
    return this.tabSelections[this.tabIndex];
  }
  set selectedStoreIds(val: Set<number>) {
    this.tabSelections[this.tabIndex] = val;
  }

  get selectedOnly(): boolean {
    return this.tabSelectedOnly[this.tabIndex];
  }
  set selectedOnly(val: boolean) {
    this.tabSelectedOnly[this.tabIndex] = val;
  }

  get currentStores(): any[] {
    let stores = this.tabIndex === 0 ? this.allStores : this.tabIndex === 1 ? this.sushiStores : this.bentoStores;
    if (this.searchText) {
      stores = stores.filter(s => s.name.toLowerCase().includes(this.searchText.toLowerCase()));
    }
    if (this.selectedOnly) {
      stores = stores.filter(s => this.selectedStoreIds.has(s.id));
    }
    return stores;
  }

  isStoreInLY(store: any): boolean {
    if (!this.includeSameStoreLY || !Array.isArray(this.lastYearSameWeekStoreInfo)) return true;
    const allowedIds = this.lastYearSameWeekStoreInfo.map((info: any) => Number(info.shop_id));
    return allowedIds.includes(Number(store.id));
  }

  isAllSelected(): boolean {
    const stores = this.currentStores;
    return stores.length > 0 && stores.every(s => this.selectedStoreIds.has(s.id));
  }

  toggleAll() {
    const stores = this.currentStores;
    if (this.isAllSelected()) {
      stores.forEach(s => this.selectedStoreIds.delete(s.id));
    } else {
      stores.forEach(s => this.selectedStoreIds.add(s.id));
    }
  }

  toggleStore(store: any) {
    if (this.selectedStoreIds.has(store.id)) {
      this.selectedStoreIds.delete(store.id);
    } else {
      this.selectedStoreIds.add(store.id);
    }
  }

  selectAllCurrentTab() {
    const stores = this.tabIndex === 0 ? this.allStores : this.tabIndex === 1 ? this.sushiStores : this.bentoStores;
    stores.forEach(s => this.selectedStoreIds.add(s.id));
  }

  selectAllTabs() {
    [this.allStores, this.sushiStores, this.bentoStores].forEach((stores, idx) => {
      this.tabSelections[idx] = new Set(stores.map(s => s.id));
    });
  }
  onIncludeSameStoreLYChange(val: boolean) {
    this.includeSameStoreLY = val;
    if (val && Array.isArray(this.lastYearSameWeekStoreInfo)) {
      const allowedIds = this.lastYearSameWeekStoreInfo.map((info: any) => Number(info.shop_id));
      // Unselect all, then select only LY stores
      this.selectedStoreIds.clear();
      let stores = this.tabIndex === 0 ? this.allStores : this.tabIndex === 1 ? this.sushiStores : this.bentoStores;
      stores.forEach(s => {
        if (allowedIds.includes(Number(s.id))) {
          this.selectedStoreIds.add(s.id);
        }
      });
    }
    // If unchecked, do not change selection
  }
  onApply() {
    // console.log(this.selectedStoreIds)
    this.dialogRef.close({
      selectedStoreIds: Array.from(this.selectedStoreIds),
      tabIndex: this.tabIndex,
      includeSameStoreLY: this.includeSameStoreLY
    });
  }

  isIndeterminate(): boolean {
    const stores = this.currentStores;
    const selectedCount = stores.filter(s => this.selectedStoreIds.has(s.id)).length;
    return selectedCount > 0 && selectedCount < stores.length;
  }

  onCancel() {
    this.dialogRef.close();
  }
}
